import type { TicketPricingBreakdown as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** What a buyer pays for one ticket, fee by fee, as the server prices it. */
export type TicketPricingBreakdown = {
  price: number;
  venueFee: number;
  platformFee: number;
  ccFee: number;
  taxFee: number;
  displayPrice: number;
};

export const fromGql = (item: GQLItem): TicketPricingBreakdown =>
  take<TicketPricingBreakdown>(item, 'price', 'venueFee', 'platformFee', 'ccFee', 'taxFee', 'displayPrice');
